import { useMutation } from '@apollo/client';

import { DeleteMerchantSandboxAccountInput } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { DeleteMerchantSandboxAccountDocument } from './graphql/deleteMerchantSandboxAccount.gql';

export const useDeleteMerchantSandboxAccountMutation = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is undefined in useDeleteMerchantSandboxAccount',
    );
  }

  const [mutation, result] = useMutation(DeleteMerchantSandboxAccountDocument, {
    update: (cache, { data }) => {
      if (!data) {
        return;
      }

      cache.modify({
        fields: {
          merchantAccount() {
            return null;
          },
        },
        id: cache.identify({
          __typename: `Company`,
          companyProfileId,
        }),
      });
    },
  });

  const deleteMerchantSandboxAccount = (
    input: DeleteMerchantSandboxAccountInput,
  ) =>
    mutation({
      variables: { input },
    });

  return [deleteMerchantSandboxAccount, result] as const;
};
